// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --shadow: -2px 2px 8px 4px rgba(34, 60, 80, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/app/providers/theme/shadow.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;AAClD","sourcesContent":[":root {\r\n  --shadow: -2px 2px 8px 4px rgba(34, 60, 80, 0.1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
